import Scene from 'scenejs';


function getTransitionTime(objectSpeed, objectDuration) {
  let percentage = 0;
  if (objectSpeed <= 100) {
    percentage = 10;
  }
  if (objectSpeed <= 80) {
    percentage = 19;
  }
  if (objectSpeed <= 60) {
    percentage = 30;
  }
  if (objectSpeed <= 40) {
    percentage = 38;
  }
  if (objectSpeed <= 20) {
    percentage = 47;
  }
  return (objectDuration / 100) * percentage;
}

function getNewTransitionsTime(transitionObject) { // specifically for the transitions only, not for the animations
  const max         = Math.min(5, Math.min(transitionObject.firstScreenDuration / 2, transitionObject.secondScreenDuration / 2));
  const range       = max - 0.1;
  const objectSpeed = transitionObject.speed;
  if (objectSpeed <= 20) {
    return range / 5;
  }
  if (objectSpeed <= 40) {
    return range / 4;
  }
  if (objectSpeed <= 60) {
    return range / 3;
  }
  if (objectSpeed <= 80) {
    return range / 2;
  }
  if (objectSpeed <= 100) {
    return range;
  }
}

function calculateSpeed(objectSpeed) {
  if (objectSpeed >= 1 && objectSpeed <= 25) {
    return 1;
  }
  if (objectSpeed >= 26 && objectSpeed <= 50) {
    return 2;
  }
  if (objectSpeed >= 51 && objectSpeed <= 75) {
    return 3;
  }
  return 4;
}

function getTypwriterSpeed(animation) {
  let percentage       = 0;
  const objectSpeed    = parseFloat(animation.speed);
  const objectDuration = parseFloat(animation.duration);

  if (objectSpeed <= 100) {
    percentage = 250;
  }
  if (objectSpeed <= 80) {
    percentage = 150;
  }
  if (objectSpeed <= 60) {
    percentage = 70;
  }
  if (objectSpeed <= 40) {
    percentage = 40;
  }
  if (objectSpeed <= 20) {
    percentage = 5;
  }

  return (objectDuration / 100) * percentage;
}

function spanEachCharacter(el) {
  if (el.nodeType == Node.TEXT_NODE) {
    const text = el.textContent;
    let html   = '';
    [...text].forEach((c) => {
      c     = c.replace(/ /g, '\u00a0');
      html += `<span class="animationItem">${c}</span>`;
    });

    const node = document.createElement('span');
    el.parentNode.insertBefore(node, el);
    el.parentNode.removeChild(el);
    node.outerHTML = html;
  } else {
    Array.from(el.childNodes).forEach((child) => {
      spanEachCharacter(child);
    });
  }
}

function characterWrapping(selector) {
  let newHTML          = '';
  const originalHTML   = document.querySelector(selector).innerHTML;
  let tagStarted       = false;
  let ampersendStarted = false;
  for (let i = 0; i < originalHTML.length; i += 1) { // lettering
    if (originalHTML[i] === '<' && !ampersendStarted) {
      tagStarted = true;
    }
    if (originalHTML[i] === '&' && !tagStarted) {
      ampersendStarted = true;
      newHTML          = `${newHTML}<span class="animationItem" >`;
    }
    if (!tagStarted && !ampersendStarted) {
      newHTML = `${newHTML}<span class="animationItem" >${originalHTML[i]}</span>`;
    } else {
      newHTML += originalHTML[i];
    }
    if (originalHTML[i] === '>' && tagStarted) {
      tagStarted = false;
    }
    if (originalHTML[i] === ';' && ampersendStarted) {
      ampersendStarted = false;
      newHTML          = `${newHTML}</span>`;
    }
  }
  document.querySelector(selector).innerHTML = newHTML;
}

export function panleft({
  animation, type, scaleX, scaleY, RotateDegree, objectOpacity,
}) {
  const start            = parseFloat(animation.startTime);
  const speed            = parseFloat(animation.speed);
  const duration         = parseFloat(animation.duration);
  let transitionDuration = 0.0;
  transitionDuration     = getTransitionTime(speed, duration);
  const distance         = parseFloat(animation.distance) + 20;
  const animationSteps   = {};

  if (animation.onEnter) {
    animationSteps[start]                      = {
      transform: {
        scale:      type === 'text' ? `${scaleX},${scaleY}` : undefined,
        translateX: `${distance}%`,
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
    animationSteps[start + transitionDuration] = {
      transform: {
        scale:      type === 'text' ? `${scaleX},${scaleY}` : undefined,
        translateX: '0%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (!animation.onEnter) {
    animationSteps[start] = {
      transform: {
        scale:      type === 'text' ? `${scaleX},${scaleY}` : undefined,
        translateX: '0%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }

  if (animation.onExit) {
    animationSteps[start + duration - transitionDuration] = {
      transform: {
        scale:      type === 'text' ? `${scaleX},${scaleY}` : undefined,
        translateX: '0%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
    animationSteps[start + duration]                      = {
      transform: {
        scale:      type === 'text' ? `${scaleX},${scaleY}` : undefined,
        translateX: `-${distance}%`,
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (!animation.onExit) {
    animationSteps[start + duration - 0.000001] = {
      opacity: objectOpacity,
    };
    animationSteps[start + duration]            = {
      opacity: objectOpacity,
    };
  }

  const item = new Scene({
    [animation.selector]: animationSteps,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });

  return item;
}

export function panright({
  animation, type, scaleX, scaleY, RotateDegree, objectOpacity,
}) {
  const start            = parseFloat(animation.startTime);
  const speed            = parseFloat(animation.speed);
  const duration         = parseFloat(animation.duration);
  let transitionDuration = 0.0;
  transitionDuration     = getTransitionTime(speed, duration);
  const distance         = parseFloat(animation.distance) + 20;
  const animationSteps   = {};
  animationSteps[0.0]    = {
  };
  if (animation.onEnter) {
    animationSteps[start]                      = {
      transform: {
        scale:      type === 'text' ? `${scaleX},${scaleY}` : undefined,
        translateX: `-${distance}%`,
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
    animationSteps[start + transitionDuration] = {
      transform: {
        scale:      type === 'text' ? `${scaleX},${scaleY}` : undefined,
        translateX: '0%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (!animation.onEnter) {
    animationSteps[start] = {
      transform: {
        scale:      type === 'text' ? `${scaleX},${scaleY}` : undefined,
        translateX: '0%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }

  if (animation.onExit) {
    animationSteps[start + duration - transitionDuration] = {
      transform: {
        scale:      type === 'text' ? `${scaleX},${scaleY}` : undefined,
        translateX: '0%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
    animationSteps[start + duration]                      = {
      transform: {
        scale:      type === 'text' ? `${scaleX},${scaleY}` : undefined,
        translateX: `${distance}%`,
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (!animation.onExit) {
    animationSteps[start + duration - 0.0001] = {
      opacity: objectOpacity,
    };
    animationSteps[start + duration]          = {
      opacity: objectOpacity,
    };
  }

  const item = new Scene({
    [animation.selector]: animationSteps,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });

  return item;
}

export function pantop({
  animation, type, scaleX, scaleY, RotateDegree, objectOpacity,
}) {
  const start            = parseFloat(animation.startTime);
  const speed            = parseFloat(animation.speed);
  const duration         = parseFloat(animation.duration);
  let transitionDuration = 0.0;
  transitionDuration     = getTransitionTime(speed, duration);
  const distance         = parseFloat(animation.distance) + 20;

  const animationSteps = {};

  if (animation.onEnter) {
    animationSteps[start]                      = {
      transform: {
        scale:      type === 'text' ? `${scaleX},${scaleY}` : undefined,
        translateY: `${distance}%`,
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
    animationSteps[start + transitionDuration] = {
      transform: {
        scale:      type === 'text' ? `${scaleX},${scaleY}` : undefined,
        translateY: '0%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (!animation.onEnter) {
    animationSteps[start] = {
      transform: {
        scale:      type === 'text' ? `${scaleX},${scaleY}` : undefined,
        translateY: '0%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }

  if (animation.onExit) {
    animationSteps[start + duration - transitionDuration] = {
      transform: {
        scale:      type === 'text' ? `${scaleX},${scaleY}` : undefined,
        translateY: '0%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
    animationSteps[start + duration]                      = {
      transform: {
        scale:      type === 'text' ? `${scaleX},${scaleY}` : undefined,
        translateY: `-${distance}%`,
        rotate:     `${RotateDegree}deg`,
      },
      opacity: 1,
    };
  }
  if (!animation.onExit) {
    animationSteps[start + duration - 0.0001] = {
      opacity: objectOpacity,
    };
    animationSteps[start + duration]          = {
      opacity: objectOpacity,
    };
  }

  const item = new Scene({
    [animation.selector]: animationSteps,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });

  return item;
}

export function panbottom({
  animation, type, scaleX, scaleY, RotateDegree, objectOpacity,
}) {
  const start            = parseFloat(animation.startTime);
  const speed            = parseFloat(animation.speed);
  const duration         = parseFloat(animation.duration);
  let transitionDuration = 0.0;
  transitionDuration     = getTransitionTime(speed, duration);
  const distance         = parseFloat(animation.distance) + 20;

  const animationSteps = {};

  if (animation.onEnter) {
    animationSteps[start]                      = {
      transform: {
        scale:      type === 'text' ? `${scaleX},${scaleY}` : undefined,
        translateY: `-${distance}%`,
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
    animationSteps[start + transitionDuration] = {
      transform: {
        scale:      type === 'text' ? `${scaleX},${scaleY}` : undefined,
        translateY: '0%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (!animation.onEnter) {
    animationSteps[start] = {
      transform: {
        scale:      type === 'text' ? `${scaleX},${scaleY}` : undefined,
        translateY: '0%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }

  if (animation.onExit) {
    animationSteps[start + duration - transitionDuration] = {
      transform: {
        scale:      type === 'text' ? `${scaleX},${scaleY}` : undefined,
        translateY: '0%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
    animationSteps[start + duration]                      = {
      transform: {
        scale:      type === 'text' ? `${scaleX},${scaleY}` : undefined,
        translateY: `${distance}%`,
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (!animation.onExit) {
    animationSteps[start + duration - 0.0001] = {
      opacity: objectOpacity,
    };
    animationSteps[start + duration]          = {
      opacity: objectOpacity,
    };
  }

  const item = new Scene({
    [animation.selector]: animationSteps,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });

  return item;
}

export function zoomin({
  animation, type, scaleX, scaleY, RotateDegree, objectOpacity,
}) {
  const start            = parseFloat(animation.startTime);
  const speed            = parseFloat(animation.speed);
  const duration         = parseFloat(animation.duration);
  let transitionDuration = 0.0;
  transitionDuration     = getTransitionTime(speed, duration);

  const animationSteps = {};

  if (animation.onEnter) {
    animationSteps[start]                      = {
      transformOrigin: 'center center',
      transform:       {
        scale:  type === 'text' ? `${70 / 100 * scaleX},${70 / 100 * scaleY}` : '70%',
        rotate: `${RotateDegree}deg`,
      },
      opacity: 0,
    };
    animationSteps[start + transitionDuration] = {
      transform: {
        scale:  type === 'text' ? `${scaleX},${scaleY}` : '100%',
        rotate: `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (!animation.onEnter) {
    animationSteps[start] = {
      transformOrigin: 'center center',
      transform:       {
        scale:  type === 'text' ? `${scaleX},${scaleY}` : '100%',
        rotate: `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }

  if (animation.onExit) {
    animationSteps[start + duration - transitionDuration] = {
      transformOrigin: 'center center',
      transform:       {
        scale:  type === 'text' ? `${scaleX},${scaleY}` : '100%',
        rotate: `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
    animationSteps[start + duration]                      = {
      transform: {
        scale:  type === 'text' ? `${130 / 100 * scaleX},${130 / 100 * scaleY}` : '130%',
        rotate: `${RotateDegree}deg`,
      },
      opacity: 0,
    };
  }
  if (!animation.onExit) {
    animationSteps[start + duration - 0.0001] = {
      opacity: objectOpacity,
    };
    animationSteps[start + duration]          = {
      opacity: 0,
    };
  }

  const item = new Scene({
    [animation.selector]: animationSteps,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });

  return item;
}

export function zoomout({
  animation, objectOpacity,
}) {
  const start            = parseFloat(animation.startTime);
  const speed            = parseFloat(animation.speed);
  const duration         = parseFloat(animation.duration);
  let transitionDuration = 0.0;
  transitionDuration     = getTransitionTime(speed, duration);

  const animationSteps = {};

  if (animation.onEnter) {
    animationSteps[start]                      = {
      transformOrigin: 'center center',
      transform:       {
        scale: '130%',
      },
      opacity: 0,
    };
    animationSteps[start + transitionDuration] = {
      transform: {
        scale: '100%',
      },
      opacity: objectOpacity,
    };
  }
  if (!animation.onEnter) {
    animationSteps[start] = {
      transformOrigin: 'center center',
      transform:       {
        scale: '100%',
      },
      opacity: objectOpacity,
    };
  }

  if (animation.onExit) {
    animationSteps[start + duration - transitionDuration] = {
      transformOrigin: 'center center',
      transform:       {
        scale: '100%',
      },
      opacity: objectOpacity,
    };
    animationSteps[start + duration]                      = {
      transformOrigin: 'center center',
      transform:       {
        scale: '130%',
      },
      opacity: 0,
    };
  }
  if (!animation.onExit) {
    animationSteps[start + duration - 0.0001] = {
      opacity: objectOpacity,
    };
    animationSteps[start + duration]          = {
      opacity: 0,
    };
  }

  const item = new Scene({
    [animation.selector]: animationSteps,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });

  return item;
}

export function stomp({
  animation, type, scaleX, scaleY, RotateDegree, objectOpacity,
}) {
  const start            = parseFloat(animation.startTime);
  const speed            = parseFloat(animation.speed);
  const duration         = parseFloat(animation.duration);
  let transitionDuration = 0.0;
  transitionDuration     = getTransitionTime(speed, duration);

  const animationSteps = {};

  if (animation.onEnter) {
    animationSteps[start]                               = {
      transformOrigin: 'center center',
      transform:       {
        scale:  type === 'text' ? `${1000 / 100 * scaleX},${1000 / 100 * scaleY}` : '1000%',
        rotate: `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
    animationSteps[start + transitionDuration]          = {
      transform: {
        scale:  type === 'text' ? `${scaleX},${scaleY}` : '100%',
        rotate: `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
    animationSteps[start + transitionDuration + 0.0001] = {
      transform: {
        scale:  type === 'text' ? `${scaleX},${scaleY}` : '100%',
        rotate: `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (!animation.onEnter) {
    animationSteps[start] = {
      transformOrigin: 'center center',
      transform:       {
        scale:  type === 'text' ? `${scaleX},${scaleY}` : '100%',
        rotate: `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }

  if (animation.onExit) {
    animationSteps[start + duration - transitionDuration] = {
      // transform: {
      //   scale: (ImageType == 'Image' || type == 'video' || ImageType == 'SVGImage') ? `${IsHFlipped === true ? '-100%' : '100%'},${IsVFlipped === true ? '-100%' : '100%'}` : '100%',
      // },
      opacity: objectOpacity,
    };
    animationSteps[start + duration]                      = {
      // transform: {
      //   scale: '1000%',
      // },
      opacity: 0,
    };
  }
  if (!animation.onExit) {
    animationSteps[start + duration - 0.0001] = {
      opacity: objectOpacity,
    };
    animationSteps[start + duration]          = {
      opacity: 0,
    };
  }
  const item = new Scene({
    [animation.selector]: animationSteps,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });

  return item;
}

export function fade({
  animation, objectOpacity,
}) {
  const start            = parseFloat(animation.startTime);
  const speed            = parseFloat(animation.speed);
  const duration         = parseFloat(animation.duration);
  let transitionDuration = 0.0;
  transitionDuration     = getTransitionTime(speed, duration);

  const animationSteps = {};

  if (animation.onEnter) {
    animationSteps[start]                               = {
      opacity: 0,
    };
    animationSteps[start + transitionDuration]          = {
      opacity: objectOpacity,
    };
    animationSteps[start + transitionDuration + 0.0001] = {
      opacity: objectOpacity,
    };
  }
  if (!animation.onEnter) {
    animationSteps[start] = {
      opacity: objectOpacity,
    };
  }

  if (animation.onExit) {
    animationSteps[start + duration - transitionDuration] = {
      opacity: objectOpacity,
    };
    animationSteps[start + duration]                      = {
      opacity: 0,
    };
  }
  if (!animation.onExit) {
    animationSteps[start + duration - 0.0001] = {
      opacity: objectOpacity,
    };
    animationSteps[start + duration]          = {
      opacity: 0,
    };
  }

  const item = new Scene({
    [animation.selector]: animationSteps,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });

  return item;
}

export function photoZomEnterIn({
  animation, RotateDegree, objectOpacity, ImageType, IsHFlipped, IsVFlipped,
}) {
  const start            = parseFloat(animation.startTime);
  const speed            = parseFloat(animation.speed);
  const duration         = parseFloat(animation.duration);
  let transitionDuration = 0.0;
  transitionDuration     = getTransitionTime(speed, duration);
  const animationSteps   = {};

  if (animation.onEnter) {
    animationSteps[start]                      = {
      transform: {
        scale:  ImageType == 'Image' ? `${IsHFlipped === true ? '-100%' : '100%'},${IsVFlipped === true ? '-100%' : '100%'}` : '100%',
        rotate: `${RotateDegree}deg`,
      },
      opacity: 0,
    };
    animationSteps[start + transitionDuration] = {
      transform: {
        scale:  ImageType == 'Image' ? `${IsHFlipped === true ? '-130%' : '130%'},${IsVFlipped === true ? '-130%' : '130%'}` : '130%',
        rotate: `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (!animation.onEnter) {
    animationSteps[start] = {
      transform: {
        scale:  ImageType == 'Image' ? `${IsHFlipped === true ? '-100%' : '100%'},${IsVFlipped === true ? '-100%' : '100%'}` : '100%',
        rotate: `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (animation.onExit) {
    animationSteps[start + duration - transitionDuration] = {

      opacity: objectOpacity,
    };
    animationSteps[start + duration]                      = {

      opacity: 0,
    };
  }
  if (!animation.onExit) {
    animationSteps[start + duration - transitionDuration] = {
      opacity: objectOpacity,
    };
  }

  const item = new Scene({
    [animation.selector]: animationSteps,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });
  return item;
}

export function photoZomEnterOut({
  animation, RotateDegree, objectOpacity, ImageType, IsHFlipped, IsVFlipped,
}) {
  const start            = parseFloat(animation.startTime);
  const speed            = parseFloat(animation.speed);
  const duration         = parseFloat(animation.duration);
  let transitionDuration = 0.0;
  transitionDuration     = getTransitionTime(speed, duration);
  const animationSteps   = {};

  if (animation.onEnter) {
    animationSteps[start]                      = {
      transform: {
        scale:  ImageType == 'Image' ? `${IsHFlipped === true ? '-120%' : '120%'},${IsVFlipped === true ? '-120%' : '120%'}` : '120%',
        rotate: `${RotateDegree}deg`,
      },
      opacity: 0,
    };
    animationSteps[start + transitionDuration] = {
      transform: {
        scale:  ImageType == 'Image' ? `${IsHFlipped === true ? '-100%' : '100%'},${IsVFlipped === true ? '-100%' : '100%'}` : '100%',
        rotate: `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (!animation.onEnter) {
    animationSteps[start] = {
      transform: {
        scale:  ImageType == 'Image' ? `${IsHFlipped === true ? '-100%' : '100%'},${IsVFlipped === true ? '-100%' : '100%'}` : '100%',
        rotate: `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (animation.onExit) {
    animationSteps[start + duration - transitionDuration] = {
      opacity: objectOpacity,
    };
    animationSteps[start + duration]                      = {
      opacity: 0,
    };
  }
  if (!animation.onExit) {
    animationSteps[start + duration - transitionDuration] = {
      opacity: objectOpacity,
    };
  }

  const item = new Scene({
    [animation.selector]: animationSteps,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });
  return item;
}

export function photoRiseTop({
  animation, ImageType, IsVFlipped, RotateDegree, objectOpacity, IsHFlipped,
}) {
  const start            = parseFloat(animation.startTime);
  const speed            = parseFloat(animation.speed);
  const duration         = parseFloat(animation.duration);
  let transitionDuration = 0.0;
  transitionDuration     = getTransitionTime(speed, duration);
  const animationSteps   = {};

  if (animation.onEnter) {
    animationSteps[start]                      = {
      transform: {
        scale:      ImageType == 'Image' ? `${IsHFlipped === true ? '-100%' : '100%'},${IsVFlipped === true ? '-100%' : '100%'}` : '100%',
        translateY: ImageType == 'Image' ? `${IsVFlipped === true ? '0%' : '0%'}` : '0%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: 0,
    };
    animationSteps[start + 0.0001]             = {
      transform: {
        scale:  ImageType == 'Image' ? `${IsHFlipped === true ? '-120%' : '120%'},${IsVFlipped === true ? '-120%' : '120%'}` : '120%',
        rotate: `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
    animationSteps[start + transitionDuration] = {
      transform: {
        translateY: ImageType == 'Image' ? `${IsVFlipped === true ? '5%' : '-5%'}` : '-5%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (!animation.onEnter) {
    animationSteps[start] = {
      transform: {
        scale:      ImageType == 'Image' ? `${IsHFlipped === true ? -1 : 1},${IsVFlipped === true ? -1 : 1}` : undefined,
        translateY: ImageType == 'Image' ? `${IsVFlipped === true ? '0%' : '0%'}` : '0%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (animation.onExit) {
    animationSteps[start + duration - transitionDuration] = {
      opacity: objectOpacity,
    };
    animationSteps[start + duration]                      = {
      opacity: 0,
    };
  }
  if (!animation.onExit) {
    animationSteps[start + duration - transitionDuration] = {
      opacity: objectOpacity,
    };
  }

  const item = new Scene({
    [animation.selector]: animationSteps,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });
  return item;
}

export function photoRiseBottom({
  animation, RotateDegree, objectOpacity, ImageType, IsHFlipped, IsVFlipped,
}) {
  const start            = parseFloat(animation.startTime);
  const speed            = parseFloat(animation.speed);
  const duration         = parseFloat(animation.duration);
  let transitionDuration = 0.0;
  transitionDuration     = getTransitionTime(speed, duration);
  const animationSteps   = {};

  if (animation.onEnter) {
    animationSteps[start]                      = {
      transform: {
        scale:      ImageType == 'Image' ? `${IsHFlipped === true ? '-100%' : '100%'},${IsVFlipped === true ? '-100%' : '100%'}` : '100%',
        translateY: ImageType == 'Image' ? `${IsVFlipped === true ? '0%' : '0%'}` : '0%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: 0,
    };
    animationSteps[start + 0.0001]             = {
      transform: {
        scale:  ImageType == 'Image' ? `${IsHFlipped === true ? '-120%' : '120%'},${IsVFlipped === true ? '-120%' : '120%'}` : '120%',
        rotate: `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
    animationSteps[start + transitionDuration] = {
      transform: {
        translateY: ImageType == 'Image' ? `${IsVFlipped === true ? '-5%' : '5%'}` : '5%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (!animation.onEnter) {
    animationSteps[start] = {
      transform: {
        scale:      ImageType == 'Image' ? `${IsHFlipped === true ? -1 : 1},${IsVFlipped === true ? -1 : 1}` : undefined,
        translateY: ImageType == 'Image' ? `${IsVFlipped === true ? '0%' : '0%'}` : '0%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (animation.onExit) {
    animationSteps[start + duration - transitionDuration] = {
      opacity: objectOpacity,
    };
    animationSteps[start + duration]                      = {
      opacity: 0,
    };
  }
  if (!animation.onExit) {
    animationSteps[start + duration - transitionDuration] = {
      opacity: objectOpacity,
    };
  }

  const item = new Scene({
    [animation.selector]: animationSteps,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });
  return item;
}

export function photoRiseLeft({
  animation, RotateDegree, objectOpacity, ImageType, IsHFlipped, IsVFlipped,
}) {
  const start            = parseFloat(animation.startTime);
  const speed            = parseFloat(animation.speed);
  const duration         = parseFloat(animation.duration);
  let transitionDuration = 0.0;
  transitionDuration     = getTransitionTime(speed, duration);
  const animationSteps   = {};

  if (animation.onEnter) {
    animationSteps[start]                      = {
      transform: {
        scale:      ImageType == 'Image' ? `${IsHFlipped === true ? '-100%' : '100%'},${IsVFlipped === true ? '-100%' : '100%'}` : '100%',
        translateX: ImageType == 'Image' ? `${IsVFlipped === true ? '0%' : '0%'}` : '0%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: 0,
    };
    animationSteps[start + 0.0001]             = {
      transform: {
        scale:  ImageType == 'Image' ? `${IsHFlipped === true ? '-120%' : '120%'},${IsVFlipped === true ? '-120%' : '120%'}` : '120%',
        rotate: `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
    animationSteps[start + transitionDuration] = {
      transform: {
        translateX: ImageType == 'Image' ? `${IsHFlipped === true ? '5%' : '-5%'}` : '-5%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (!animation.onEnter) {
    animationSteps[start] = {
      transform: {
        scale:      ImageType == 'Image' ? `${IsHFlipped === true ? -1 : 1},${IsVFlipped === true ? -1 : 1}` : undefined,
        translateX: ImageType == 'Image' ? `${IsVFlipped === true ? '0%' : '0%'}` : '0%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (animation.onExit) {
    animationSteps[start + duration - transitionDuration] = {
      opacity: objectOpacity,
    };
    animationSteps[start + duration]                      = {
      opacity: 0,
    };
  }
  if (!animation.onExit) {
    animationSteps[start + duration - transitionDuration] = {
      opacity: objectOpacity,
    };
  }

  const item = new Scene({
    [animation.selector]: animationSteps,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });
  return item;
}

export function photoRiseRight({
  animation, RotateDegree, objectOpacity, ImageType, IsHFlipped, IsVFlipped,
}) {
  const start            = parseFloat(animation.startTime);
  const speed            = parseFloat(animation.speed);
  const duration         = parseFloat(animation.duration);
  let transitionDuration = 0.0;
  transitionDuration     = getTransitionTime(speed, duration);

  const animationSteps = {};

  if (animation.onEnter) {
    animationSteps[start]                      = {
      transform: {
        scale:      ImageType == 'Image' ? `${IsHFlipped === true ? '-100%' : '100%'},${IsVFlipped === true ? '-100%' : '100%'}` : '100%',
        translateX: ImageType == 'Image' ? `${IsVFlipped === true ? '0%' : '0%'}` : '0%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: 0,
    };
    animationSteps[start + 0.0001]             = {
      transform: {
        scale:  ImageType == 'Image' ? `${IsHFlipped === true ? '-120%' : '120%'},${IsVFlipped === true ? '-120%' : '120%'}` : '120%',
        rotate: `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
    animationSteps[start + transitionDuration] = {
      transform: {
        translateX: ImageType == 'Image' ? `${IsHFlipped === true ? '-5%' : '5%'}` : '5%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (!animation.onEnter) {
    animationSteps[start] = {
      transform: {
        scale:      ImageType == 'Image' ? `${IsHFlipped === true ? -1 : 1},${IsVFlipped === true ? -1 : 1}` : undefined,
        translateX: ImageType == 'Image' ? `${IsVFlipped === true ? '0%' : '0%'}` : '0%',
        rotate:     `${RotateDegree}deg`,
      },
      opacity: objectOpacity,
    };
  }
  if (animation.onExit) {
    animationSteps[start + duration - transitionDuration] = {
      opacity: objectOpacity,
    };
    animationSteps[start + duration]                      = {
      opacity: 0,
    };
  }
  if (!animation.onExit) {
    animationSteps[start + duration - transitionDuration] = {
      opacity: objectOpacity,
    };
  }

  const item = new Scene({
    [animation.selector]: animationSteps,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });

  return item;
}

export function typewriter({
  animation,
}) {
  const start        = parseFloat(animation.startTime);
  const { selector } = animation;
  if (document.querySelectorAll(`${selector} .animationItem`).length == 0) {
    characterWrapping(selector);
  }

  const numOfCharacter = [document.querySelectorAll(`${selector} .animationItem`)][0].length;
  const exitDistance   = numOfCharacter / 10;

  const animationDurationPercentage1 = getTypwriterSpeed(animation);
  const item                         = new Scene({
    [`${selector} .animationItem`]: i => ({
      0: {
        opacity: animation.onEnter ? 0 : 1,
      },
      0.24: {
        opacity: animation.onEnter ? 0 : 1,
      },
      0.25: {
        opacity: 1,
      },
      [animationDurationPercentage1]: {
        opacity: 1,
      },
      [animationDurationPercentage1 + exitDistance]: {
        opacity: 1,
      },
      [animationDurationPercentage1 + exitDistance + 0.001]: {
        opacity: animation.onExit ? 0 : 1,
      },
      options: {
        delay: (i * 0.09),
      },
    }),
  }, {
    easing:   'ease-in-out',
    selector: true,
  });
  item.setDuration(animation.parentPageDuration);
  item.setDelay(start);
  return item;
}

// export function burst({
//   animation,
// }) {
//   const start        = parseFloat(animation.startTime);
//   const { selector } = animation;
//   if (document.querySelectorAll(`${selector} .animationItem`).length == 0) {
//     characterWrapping(selector);
//   }
//   const numOfCharacter = [document.querySelectorAll(`${selector} .animationItem`)][0].length;
//   const exitDistance   = numOfCharacter / 10;
//   let exitDelay        = 2;
//   if (numOfCharacter > 300) {
//     exitDelay = 10;
//   }
//   if (numOfCharacter > 600) {
//     exitDelay = 30;
//   }

//   const animationDurationPercentage1 = getTypwriterSpeed(animation);
//   const item                         = new Scene({
//     [`${selector} .animationItem`]: i => ({
//       0: {
//         opacity: animation.onEnter ? 0 : 1,
//         display: animation.onEnter ? 'inline-block' : 'inline',
//       },
//       0.00001: {
//         opacity:   animation.onEnter ? 0 : 1,
//         transform: animation.onExit ? 'scale(1)' : 'scale(0.1)',
//       },
//       0.45: {
//         opacity:   1,
//         transform: animation.onEnter ? 'scale(1.2)' : 'scale(01)',
//       },
//       0.48: {
//         opacity:     1,
//         transform:   'scale(1.0)',
//         'font-size': '100%',
//         display:     'inline',
//       },
//       [animationDurationPercentage1]: {
//         opacity: 1,
//       },
//       [animationDurationPercentage1 + exitDistance]: {
//         opacity: 1,
//       },
//       [animationDurationPercentage1 + exitDistance + exitDelay]: {
//         opacity: animation.onExit ? 0 : 1,
//       },
//       options: {
//         delay: (i * 0.09),
//       },

//     }),
//   }, {
//     easing:   'ease-in-out',
//     selector: true,
//   });
//   item.setDuration(parseFloat(animation.parentPageDuration));
//   item.setDelay(start);
//   return item;
// }

export function burst({ animation }) {
  const start        = parseFloat(animation.startTime);
  const { selector } = animation;
  if ([document.querySelectorAll(`${selector} .animationItem`)][0].length == 0) {
    const el     = document.querySelector(selector);
    el.innerHTML = el.innerHTML.replace(/>\s+</g, '><');
    el.innerHTML = el.innerHTML.replace(/(?<!(<\/?[^>]*|&[^;]*))([^\s<]+)/g, '$1<span style="display:inline-block">$2</span>');
    spanEachCharacter(document.querySelector(`${selector}`));
  }
  const numOfCharacter = [document.querySelectorAll(`${selector} .animationItem`)][0].length;
  const exitDistance   = numOfCharacter / 10;
  let exitDelay        = 2;
  if (numOfCharacter > 300) {
    exitDelay = 10;
  }
  if (numOfCharacter > 600) {
    exitDelay = 30;
  }
  const animationDurationPercentage1 = getTypwriterSpeed(animation);
  const item                         = new Scene({
    [`${selector} .animationItem`]: i => ({
      0: {
        opacity: animation.onEnter ? 0 : 1,
        display: 'inline-flex',
      },
      0.00001: {
        opacity:   animation.onEnter ? 0 : 1,
        transform: animation.onExit && !animation.onEnter ? 'scale(1)' : 'scale(0.1)',
      },
      0.45: {
        opacity:   1,
        transform: animation.onEnter ? 'scale(1.2)' : 'scale(01)',
      },
      0.48: {
        opacity:   1,
        transform: 'scale(1.0)',
      },
      [animationDurationPercentage1]: {
        opacity: 1,
      },
      [animationDurationPercentage1 + exitDistance]: {
        opacity: 1,
      },
      [animationDurationPercentage1 + exitDistance + exitDelay]: {
        opacity: animation.onExit ? 0 : 1,
      },
      options: {
        delay: (i * 0.09),
      },
    }),
  }, {
    easing:   'ease-in-out',
    selector: true,
  });
  item.setDuration(parseFloat(animation.parentPageDuration));
  item.setDelay(start);
  return item;
}

export function transitionPanLeft(tranition, index) {
  const trScene           = new Scene();
  const tansitionDuration = getNewTransitionsTime(tranition);

  if (index == 0) {
    const ani       = {
      0: {
        left: 0,
      },
    };
    const tempScene = new Scene({
      '.page-0': ani,
    });
    trScene.setItem('page-0', tempScene);
  }

  const a1                  = {
    0: {
      'z-index': 6 - index,
    },
    [tranition.secondScreenStartTime - tansitionDuration - 0.001]: {
      left: '0',
    },
    [tranition.secondScreenStartTime - tansitionDuration]: {
      left: '0',
    },
    [tranition.secondScreenStartTime + tansitionDuration]: {
      left: '-100%',
    },
  };
  const a2                  = {
    0: {
      left: '100%',
    },
    [tranition.secondScreenStartTime - tansitionDuration]: {
      left: '100%',
    },
    [tranition.secondScreenStartTime + tansitionDuration]: {
      left: '0',
    },
  };
  const page1               = `.page-${index}`;
  const page2               = `.page-${index + 1}`;
  const transitionPageScene = new Scene({
    [page1]: a1,
    [page2]: a2,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });
  trScene.setItem(`transition${index}`, transitionPageScene);


  return trScene;
}

export function transitionPanRight(tranition, index) {
  const trScene           = new Scene();
  const tansitionDuration = getNewTransitionsTime(tranition);

  if (index == 0) {
    const ani       = {
      0: {
        left: 0,
      },
    };
    const tempScene = new Scene({
      '.page-0': ani,
    });
    trScene.setItem('page-0', tempScene);
  }

  const a1                  = {
    0: {
      'z-index': 6 - index,
    },
    [tranition.secondScreenStartTime - tansitionDuration - 0.001]: {
      left: '0',
    },
    [tranition.secondScreenStartTime - tansitionDuration]: {
      left: '0',
    },
    [tranition.secondScreenStartTime + tansitionDuration]: {
      left: '100%',
    },
  };
  const a2                  = {
    0: {
      left: '-100%',
    },
    [tranition.secondScreenStartTime - tansitionDuration]: {
      left: '-100%',
    },
    [tranition.secondScreenStartTime + tansitionDuration]: {
      left: '0',
    },
  };
  const page1               = `.page-${index}`;
  const page2               = `.page-${index + 1}`;
  const transitionPageScene = new Scene({
    [page1]: a1,
    [page2]: a2,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });
  trScene.setItem(`transition${index}`, transitionPageScene);


  return trScene;
}

export function transitionPanTop(tranition, index) {
  const trScene           = new Scene();
  const tansitionDuration = getNewTransitionsTime(tranition);

  if (index == 0) {
    const ani       = {
      0: {
        top:  0,
        left: 0,
      },
    };
    const tempScene = new Scene({
      '.page-0': ani,
    });
    trScene.setItem('page-0', tempScene);
  }

  const a1                  = {
    0: {
      'z-index': 6 - index,
      left:      0,
    },
    [tranition.secondScreenStartTime - tansitionDuration - 0.001]: {
      top: '0',
    },
    [tranition.secondScreenStartTime - tansitionDuration]: {
      top: '0',
    },
    [tranition.secondScreenStartTime + tansitionDuration]: {
      top: '-100%',
    },
  };
  const a2                  = {
    0: {
      top:  '100%',
      left: 0,
    },
    [tranition.secondScreenStartTime - tansitionDuration]: {
      top: '100%',
    },
    [tranition.secondScreenStartTime + tansitionDuration]: {
      top: '0',
    },
  };
  const page1               = `.page-${index}`;
  const page2               = `.page-${index + 1}`;
  const transitionPageScene = new Scene({
    [page1]: a1,
    [page2]: a2,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });
  trScene.setItem(`transition${index}`, transitionPageScene);


  return trScene;
}

export function transitionPanBottom(tranition, index) {
  const trScene           = new Scene();
  const tansitionDuration = getNewTransitionsTime(tranition);

  if (index == 0) {
    const ani       = {
      0: {
        top:  0,
        left: 0,
      },
    };
    const tempScene = new Scene({
      '.page-0': ani,
    });
    trScene.setItem('page-0', tempScene);
  }

  const a1                  = {
    0: {
      'z-index': 6 - index,
      left:      0,
    },
    [tranition.secondScreenStartTime - tansitionDuration - 0.001]: {
      top: '0',
    },
    [tranition.secondScreenStartTime - tansitionDuration]: {
      top: '0',
    },
    [tranition.secondScreenStartTime + tansitionDuration]: {
      top: '100%',
    },
  };
  const a2                  = {
    0: {
      top:  '-100%',
      left: 0,
    },
    [tranition.secondScreenStartTime - tansitionDuration]: {
      top: '-100%',
    },
    [tranition.secondScreenStartTime + tansitionDuration]: {
      top: '0',
    },
  };
  const page1               = `.page-${index}`;
  const page2               = `.page-${index + 1}`;
  const transitionPageScene = new Scene({
    [page1]: a1,
    [page2]: a2,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });
  trScene.setItem(`transition${index}`, transitionPageScene);


  return trScene;
}


export function transitionFade(tranition, index) {
  const trScene           = new Scene();
  const tansitionDuration = getNewTransitionsTime(tranition);

  if (index == 0) {
    const ani       = {
      0: {
        opacity:   1,
        left:      0,
        transform: 'translate(0)',
      },
    };
    const tempScene = new Scene({
      '.page-0': ani,
    });
    trScene.setItem('page-0', tempScene);
  }

  const a1                  = {
    0: {
      'z-index': 6 - index,
      left:      0,
      transform: 'translate(0)',
    },
    [tranition.secondScreenStartTime - tansitionDuration - 0.001]: {
      opacity: '1',
    },
    [tranition.secondScreenStartTime - tansitionDuration]: {
      opacity: '1',
    },
    [tranition.secondScreenStartTime + tansitionDuration]: {
      opacity: '0',
    },
  };
  const a2                  = {
    0: {
      opacity:   '1',
      left:      0,
      transform: 'translate(0)',
    },
    [tranition.secondScreenStartTime - tansitionDuration - 0.0001]: {
      opacity: '1',
    },
    [tranition.secondScreenStartTime - tansitionDuration]: {
      opacity: '1',
    },
    [tranition.secondScreenStartTime + tansitionDuration]: {
      opacity: '1',
    },
  };
  const page1               = `.page-${index}`;
  const page2               = `.page-${index + 1}`;
  const transitionPageScene = new Scene({
    [page1]: a1,
    [page2]: a2,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });
  trScene.setItem(`transition${index}`, transitionPageScene);


  return trScene;
}

export function transitionNone(tranition, index) {
  const trScene = new Scene();

  if (index == 0) {
    const ani       = {
      0: {
        opacity:   1,
        'z-index': 6 - index,
        left:      0,
        transform: 'translate(0)',
      },
      0.001: {
        opacity:   1,
        'z-index': 6 - index,
      },
      [tranition.secondScreenStartTime - 0.001]: {
        opacity:   1,
        'z-index': 6 - index,
      },
    };
    const tempScene = new Scene({
      '.page-0': ani,
    });
    trScene.setItem('page-0', tempScene);
  }

  const a1                  = {
    0: {
      'z-index': 6 - index,
      opacity:   1,
      left:      0,
      transform: 'translate(0)',
    },

    [tranition.firstScreenStartTime]: {
      opacity:   '1',
      'z-index': 6 - index,
      left:      0,
    },
    [tranition.firstScreenStartTime + 0.001]: {
      opacity:   '1',
      'z-index': 6 - index,
      left:      0,
    },
    [tranition.firstScreenStartTime + tranition.firstScreenDuration - 0.001]: {
      opacity:   '1',
      'z-index': 6 - index,
      left:      0,
    },
    [tranition.firstScreenStartTime + tranition.firstScreenDuration]: {
      opacity:   '0',
      'z-index': 6 - index,
      left:      0,

    },
  };
  const a2                  = {
    0: {
      opacity:   '0',
      left:      0,
      transform: 'translate(0)',
      'z-index': 6 - index,
    },
    [tranition.secondScreenStartTime]: {
      opacity: '1',
      'z-index': 6 - index,
    },
    [tranition.secondScreenStartTime + 0.001]: {
      opacity: '1',
      'z-index': 6 - index,
    },
    [tranition.secondScreenStartTime + tranition.secondScreenDuration]: {
      opacity: '1',
      'z-index': 6 - index,
    },
  };
  const page1               = `.page-${index}`;
  const page2               = `.page-${index + 1}`;
  const transitionPageScene = new Scene({
    [page1]: a1,
    [page2]: a2,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });
  trScene.setItem(`transition${index}`, transitionPageScene);
  return trScene;
}

export function singlePageDisplay(animation) {
  const ani                 = {
    0: {
      opacity: 1,
    },
    [animation.duration]: {
      opacity: 1,
      left:0
    },
  };
  const transitionPageScene = new Scene({
    '.page-0': ani,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });
  return transitionPageScene;
}

export function lastPageDisplay(transition, index) {
  const ani                 = {
    [transition.secondScreenStartTime - 0.001]: {
      opacity: 0,
    },
    [transition.secondScreenStartTime - 0.001]: {
      opacity: 1,
    },
    [transition.secondScreenStartTime + transition.secondScreenDuration]: {
      opacity: 1,
    },
    [transition.secondScreenStartTime + transition.secondScreenDuration + 0.001]: {
      opacity: 0,
    },
  };
  const transitionPageScene = new Scene({
    [`.page-${index}`]: ani,
  }, {
    easing:   'ease-in-out',
    selector: true,
  });
  return transitionPageScene;
}
